import VSelect from 'vuetify/es5/components/VSelect/VSelect';

const OPTIONS = [
  { text: 'Cédula de Ciudadanía', value: 'cc' },
  { text: 'NIT', value: 'nit' },
]

export default {
  name: 'vat-type-select',

  extends: VSelect,

  props: {
    multiple: { type: Boolean, default: false },
    items: { type: Array, default: () => OPTIONS },
    label: { type: String, default: 'Tipo de Identificación' },
  },
};
